import React from 'react'
import PropTypes from 'prop-types'
import MediaUploadModal from 'pages/widgets/form/media-upload'
import DownloadMosaicTemplate from '../download-mosaic-template'
import ProceedUploadModal from 'components/form/proceed-upload-modal'

const photoMosaicTemplateUrl = process.env.REACT_APP_PHOTOMOSAIC_TEMPLATE_URL

export class UploadMosaicButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      show: false,
      showWarning: false
    }

    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleDownload = this.handleDownload.bind(this)

    this.handleWarningShow = this.handleWarningShow.bind(this)
    this.handleWarningHide = this.handleWarningHide.bind(this)
  }

  handleShow () {
    this.setState({ show: true, showWarning: false })
  }

  handleClose () {
    this.setState({ show: false })
  }

  handleWarningShow () {
    this.setState({ showWarning: true })
  }

  handleWarningHide () {
    this.setState({ showWarning: false })
  }

  handleDownload () {
    window.open(photoMosaicTemplateUrl, '_blank')
  }

  render () {
    const { value, onChange } = this.props.input

    return (
      <div>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-6'>
            <button
              type='button'
              id='br-mosaic-upload-input'
              className='btn green-haze'
              onClick={this.handleWarningShow}
              disabled={this.props.mediaId}
              style={{ width: '100%', display: 'block' }}
            >
              <i className='fa fa-image' />
              Upload Master Image
              {this.props.mediaId ? (
                <i
                  style={{ marginLeft: '8px', marginRight: '0' }}
                  className='fa fa-check'
                />
              ) : null}
            </button>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6'>
            {this.props.mediaId && (
              <DownloadMosaicTemplate onClick={this.handleDownload} />
            )}
          </div>
        </div>

        <ProceedUploadModal
          showModal={this.state.showWarning}
          hideModal={this.handleWarningHide}
          handleAccept={this.handleShow}
        />

        <div className='col-xs-12'>
          <MediaUploadModal
            showModal={this.state.show}
            hideModal={this.handleClose}
            onChange={onChange}
            value={value}
            actionType='MOSAIC_OPT_IN'
          />
        </div>
      </div>
    )
  }
}

UploadMosaicButton.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  input: PropTypes.any,
  mediaId: PropTypes.array
}

export default UploadMosaicButton



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/add-to-mosaic/mosaic/components/upload-mosaic-button/index.js